/** @format */
import isPropValid from '@emotion/is-prop-valid';
import { DynamicIconHelper } from '@mpb-com/feather/components/atoms/dynamic-icon-helper';
import {
    Icon,
    IconSize,
    IconVariant,
} from '@mpb-com/feather/components/atoms/icon';
import React, { FunctionComponent, useContext } from 'react';
import styled from 'styled-components';

import FacebookHover from '@toucan/client/global/icons/facebook-hover.svg';
import Facebook from '@toucan/client/global/icons/facebook.svg';
import InstagramHover from '@toucan/client/global/icons/instagram-active.svg';
import Instagram from '@toucan/client/global/icons/instagram.svg';
import X from '@toucan/client/global/icons/x-formally-known-as-twitter.svg';
import YoutubeHover from '@toucan/client/global/icons/youtube-active.svg';
import Youtube from '@toucan/client/global/icons/youtube.svg';

import { MarketContext } from '@toucan/client/global/market';

import {
    Link,
    LinkTarget,
    LinkVariant,
} from '@toucan/client/shared/components/link';

import { getSocialChannelLinks } from './helpers';
import { styles } from './social-channels.styles';
import { SocialChannelsProps } from './types';

const socialIcons = {
    facebook: {
        Resting: Facebook,
        Hover: FacebookHover,
    },
    instagram: {
        Resting: Instagram,
        Hover: InstagramHover,
    },
    twitter: {
        Resting: X,
        Hover: X,
    },
    youtube: {
        Resting: Youtube,
        Hover: YoutubeHover,
    },
};

const StyledSocialChannels = styled('ul').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const SocialChannels: FunctionComponent<SocialChannelsProps> = ({
    items = ['facebook', 'instagram', 'twitter', 'youtube'],
    ...otherProps
}: SocialChannelsProps) => {
    const { activeMarket } = useContext(MarketContext);
    const socialChannelUrls = getSocialChannelLinks(activeMarket.language);
    return (
        <StyledSocialChannels {...otherProps}>
            {items.map((item) => {
                const { Resting, Hover } = socialIcons[item];
                const url = socialChannelUrls[item];

                return (
                    <li key={item}>
                        <Link
                            href={url}
                            target={LinkTarget.BLANK}
                            rel="noopener noreferrer"
                            variant={LinkVariant.CUSTOM}
                            aria-label={item}
                        >
                            <Icon
                                aria-hidden="true"
                                size={IconSize.M}
                                variant={IconVariant.ACTIONABLE}
                            >
                                <DynamicIconHelper
                                    resting={Resting}
                                    hover={Hover}
                                />
                            </Icon>
                        </Link>
                    </li>
                );
            })}
        </StyledSocialChannels>
    );
};
